import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-integration-vast-form',
  templateUrl: './integration-vast-form.component.html',
  styleUrls: ['./integration-vast-form.component.scss']
})
export class IntegrationVastFormComponent {
  @Input() formGroup!: FormGroup;
}
